import cn from 'classnames';
import { FC } from 'react';

import { MaskGroup } from '@/shared/config';
import { useAppDispatch, useAppSelector } from '@/shared/hooks';
import { trackEvent } from '@/shared/lib';

import { useReportSettings } from '@/entities/reports';

import { MASK_FILTER_EVENT_MAPPING, maskFiltersModel } from '../..';
import { MaskFilterButton } from '../MaskFilterButton/MaskFilterButton';

import styles from './MaskFilters.module.scss';

const MASK_GROUP_TO_SETTINGS_KEY = {
  perio: 'ShowPerio',
  restorative: 'ShowRestorative',
  endo: 'ShowEndo',
  chart: 'ShowAnatomy',
} as const;

type MaskFiltersProps = {
  className?: string;
  testID?: string;
};

export const MaskFilters: FC<MaskFiltersProps> = (props) => {
  const { className, testID } = props;

  const dispatch = useAppDispatch();

  const filterGroups = useAppSelector(maskFiltersModel.selectors.selectFilters);
  const { updateSettings } = useReportSettings();

  const handleClick = (filterGroup: MaskGroup) => {
    const currentFilterTuple = filterGroups.find(
      ([group]) => group === filterGroup,
    );
    const filterState = currentFilterTuple?.[1];
    const isCurrentlyActive = filterState?.isActive || false;

    dispatch(maskFiltersModel.actions.toggleFilter(filterGroup));

    const settingsKey = MASK_GROUP_TO_SETTINGS_KEY[filterGroup];
    updateSettings({ [settingsKey]: !isCurrentlyActive });

    const eventName = MASK_FILTER_EVENT_MAPPING[filterGroup];
    if (eventName) {
      trackEvent({
        eventName,
        properties: {
          tog_status: isCurrentlyActive ? 'disabled' : 'enabled',
        },
      });
    }
  };

  return (
    <div
      data-testid={testID}
      className={cn(styles.container, className)}
      data-component="mask-filters"
    >
      {filterGroups.map(([filterGroup, { isActive, hide }]) =>
        hide ? null : (
          <MaskFilterButton
            key={filterGroup}
            filterGroup={filterGroup}
            active={isActive}
            onClick={handleClick}
          />
        ),
      )}
    </div>
  );
};
